(function ($) {
  $(document).on('click', '.sustera-archive-main .categories-filter input[type="radio"]', function () {
    $('.sustera-archive-main .categories-filter form').submit()
  })
})(jQuery)
